<template>

    <v-card>
        <v-card-title>
            Edit Site Tag Groupings
        </v-card-title>

        <v-divider />

        <v-card-text style="height: calc(100vh - 260px)">
            <v-window v-model="windowPage">

                <v-window-item :key="0">
                    <v-data-table style="background-color: #212121;" :headers="headers" :items="siteTagCustomGroupsClone" :search="search" item-key="unique_key" sort-by="key"
                        :items-per-page="-1" class="elevation-1 mt-3" :hide-default-footer="true">

                        <template v-slot:item.tagsCount="{ item }">
                            <span>{{ item.siteTags.length }}</span>
                        </template>

                        <template v-slot:item.actions="{ item }">
                            <v-icon class="mr-2" @click="editItemClick(item)">mdi-pencil</v-icon>
                            <v-icon @click="deleteItemClick(item)">mdi-delete</v-icon>
                        </template>
                    </v-data-table>

                    <v-btn class="mt-2" style="background-color: #c42111; float: right;" icon @click="addNewClick">
                        <v-icon>mdi-plus</v-icon>
                    </v-btn>
                </v-window-item>

                <v-window-item :key="1" v-if="windowPage == 1" class="network-map-custom-site-tag-groups-tags-container">
                    <v-form ref="siteTagGroupDetailsForm" :lazy-validation="true" v-model="formValid">
                        <v-row>
                            <v-col cols="4">
                                <v-text-field autocomplete="off" label="Site Tag Group Name" color="#c42111" v-model="siteTagCustomGroupEdit.name" :rules="[validation.required(siteTagCustomGroupEdit.name)]" />
                            </v-col>
                            <v-col cols="8">
                                <v-text-field autocomplete="off" label="Site Tag Group Description" color="#c42111" v-model="siteTagCustomGroupEdit.description" :rules="[validation.required(siteTagCustomGroupEdit.name)]" />
                            </v-col>
                            <v-col cols="12">
                                <v-data-table class="tag-table" height="calc(100vh - 555px)" style="background-color: #212121; display: grid;" v-model="siteTagCustomGroupEdit.siteTags" :dense="true" :headers="siteTagsHeaders" :items="$props.siteTags" 
                                    :search="siteTagSearch" item-key="site_group_id" sort-by="site_group_name" :items-per-page="50" fixed-header show-select :footer-props="siteTagsFooterProps">
                                    <template v-slot:top>
                                        <v-text-field v-model="siteTagSearch" class="ml-4 mr-4" color="#c42111" placeholder="Site Tag Search" height="20" />
                                    </template>
                                </v-data-table>
                            </v-col>
                        </v-row>
                    </v-form>
                    
                    <v-btn class="mt-0" style="float: right;" color="#c42111" @click="okClick">ok</v-btn>
                </v-window-item>

            </v-window>
        </v-card-text>

        <v-divider />

        <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn text :disabled="windowPage == 1" @click="$emit('close')">Close</v-btn>
            <v-btn text :disabled="windowPage == 1" @click="$emit('save', siteTagCustomGroupsClone)">Save</v-btn>
        </v-card-actions>
    </v-card>

</template>

<script>
export default {
    name: 'SiteTagCustomGroupsEdit',
    props: ['siteTags', 'siteTagCustomGroups'],
    components: {

    },
    data: () => ({
        windowPage: 0,

        siteTagCustomGroupsClone: null,

        search: '',
        headers: [
            {text: 'Name', align: 'start', filterable: true, groupable: false, value: 'name'},
            {text: 'Description', align: 'start', filterable: true, groupable: false, value: 'description'},
            {text: 'Number of Tags', align: 'start', filterable: true, groupable: false, value: 'tagsCount'},
            {text: 'Actions', filterable: false, groupable: false, value: 'actions'},
        ],
        siteTagCustomGroupEdit: null,
        addNew: false,
        formValid: true,
        siteTagsHeaders: [
            {text: 'Name', align: 'start', filterable: true, groupable: false, value: 'site_group_name'},
            {text: 'Description', align: 'start', filterable: true, groupable: false, value: 'site_group_desc'},
        ],
        siteTagSearch: '',
        siteTagsFooterProps: {
            'items-per-page-options': [50, 100, 250, 500, 100, -1]
        },
        validation: {
            required: (value) => (!!value || `Value required`),
            uniqueName: (groupName, siteTagGroups) => (!siteTagGroups.some(g => g.name == groupName) || 'This group name is already in use.')
        },
    }),

    computed: {

    },

    methods: {
        addNewClick: function() {
            this.siteTagCustomGroupEdit = {
                name: '',
                description: '',
                siteTags: [],
                //groupId: 0
            };
            this.addNew = true;
            this.windowPage = 1;
        },

        editItemClick: function(siteTagCustomGroup) {
            this.siteTagCustomGroupEdit = siteTagCustomGroup;
            this.windowPage = 1;
        },

        deleteItemClick: function(siteTagCustomGroups) {
            this.siteTagCustomGroupsClone.splice(this.siteTagCustomGroupsClone.indexOf(siteTagCustomGroups), 1);
        },

        okClick: function() {
            if(this.$refs.siteTagGroupDetailsForm.validate()) {
                if(this.addNew) {
                    this.siteTagCustomGroupsClone.push(this.siteTagCustomGroupEdit);
                }
                this.windowPage = 0;
                this.addNew = false;
            }
        }
    },

    created() {
        this.siteTagCustomGroupsClone = JSON.parse(JSON.stringify(this.$props.siteTagCustomGroups));
    },

    mounted() {

    }

  
};
</script>

<style>

    .network-map-custom-site-tag-groups-tags-container .theme--dark.v-data-table.v-data-table--fixed-header thead th {
        background-color: #212121 !important;
    }

</style>
